import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import OutlookIcon from '@/public/icons/OutlookIcon';

const currentOrigin: string =
  typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

type LoginProps = {
  redirectTo: string;
};

const OutlookLogin = ({ redirectTo }: LoginProps) => {
  const OAUTH2_REDIRECT_OUTLOOK_URI: string = `${currentOrigin}/oauth2/redirect?redirectTo=${redirectTo}`;
  const OUTLOOK_AUTH_URL: string = `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}/auth/outlook-login?referer=${OAUTH2_REDIRECT_OUTLOOK_URI}`;

  return (
    <Box>
      <a href={OUTLOOK_AUTH_URL} title="Sign in with Outlook">
        <Button
          variant="outlined"
          startIcon={<OutlookIcon />}
          fullWidth
          size="large"
          sx={{ lineHeight: 1, ':hover': 'cursor', textTransform: 'none' }}
        >
          Sign in with Outlook
        </Button>
      </a>
    </Box>
  );
};

export default OutlookLogin;
